<template>
  <v-card>
    <v-card-title>
      <v-btn
        id="btn1"
        color="primary"
        dark
        @click="dialogModal(true, 'create')"
      >
        <v-icon dark>
          mdi-plus
        </v-icon>
        {{ $('create') }}
      </v-btn>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :search="search"
      :items="data"
      :options.sync="options"
      :loading="loading"
      :footer-props="{
        itemsPerPageOptions:[10, 20, 50, -1],
        itemsPerPageText: $t('dataTable.itemsPerPageText'),
        pageText: $t('dataTable.pageText'),
        itemsPerPageAllText: $t('dataTable.itemsPerPageAllText'),
        showFirstLastPage: true,
      }"
    >
      <template v-slot:item.image="{ item }">
        <v-img :src="item.image" width="80" height="80"></v-img>
      </template>
      <template v-slot:item.author="{ item }">
        {{ item.author ? item.author.name : '-' }}
      </template>
      <template v-slot:item.article="{ item }">
        {{ item.article | short_string(60) }}
      </template>
      <template v-slot:item.actions="{ item }">
        <div id="actions" class="text-center">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                small
                icon
                color="dark"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>
                  mdi-dots-vertical
                </v-icon>
              </v-btn>
            </template>
            <v-list>
              <menu-item :label="$('update')" color="info" icon="mdi-pencil" @click="dialogModal(true, 'update', item)"></menu-item>
              <menu-item :label="$('delete')" color="error" icon="mdi-delete" @click="dialogModal(true, 'delete', item)"></menu-item>
            </v-list>
          </v-menu>
        </div>
      </template>
    </v-data-table>
    <articles-dialog
      :dialog-modal="dialogModal"
      :data="dialogData"
      :translation-key="translationKey"
      @update:table="fetch"
    ></articles-dialog>
  </v-card>
</template>

<script>
import axios from '@axios'
import articlesDialog from '@/views/pages/articles/dialog.vue'
import MenuItem from '@/components/menu/menuItem.vue';

export default {
  name: 'Articles',
  components: { articlesDialog, MenuItem },
  data: () => ({
    translationKey: 'pages.articles',
    filters: false,
    data: [],
    loading: true,
    options: {},
    tempOptions: '',
    search: '',
    dialogData: {
      dialog: false,
      type: 'create',
      id: null,
    },
    headers: [
      {
        text: 'التسلسل',
        value: 'id',
        align: 'center',
        sortable: false,
      },
      {
        text: 'الصورة',
        value: 'image',
        align: 'center',
        sortable: false,
      },
      {
        text: 'العنوان',
        value: 'title',
        align: 'center',
        sortable: true,
      },
      {
        text: 'الموضوع',
        value: 'article',
        align: 'center',
        sortable: true,
      },
      {
        text: 'بواسطة',
        value: 'author',
        align: 'center',
        sortable: true,
      },
      {
        text: 'الخيارات',
        value: 'actions',
        align: 'center',
      },
    ],
  }),
  mounted() {
    this.fetch();
  },

  methods: {
    async fetch() {
      this.loading = true;
      const type = this.$route.name === 'news.news' ? 1 : 0;
      const response = await axios.get(`/article/${type}`);
      this.data = response.data.data
      this.loading = false
    },
    dialogModal(dialog, type = this.dialogData.type, data = null) {
      this.dialogData.dialog = dialog;
      this.dialogData.type = type;
      this.dialogData.data = data;
    },
    diffDays(end, start = new Date()) {
      const diffInMs = end - start;
      const diffInDays = diffInMs / (1000 * 60 * 60 * 24);

      return Math.ceil(diffInDays);
    },
    $(key, parameters = null) {
      return this.$t(`${this.translationKey}.${key}`, parameters);
    },
  },

}
</script>
